module.exports = __webpack_public_path__ + "img/new_unactive_03.97b9ebc5.jpg";